module.exports = __webpack_public_path__ + "static/harit-c2a632d238a11e25335b727cdc01133a.jpeg";